import { render } from "./App.vue?vue&type=template&id=799c49e2&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=799c49e2&lang=scss"

import exportComponent from "/home/runner/work/nft_frontend/nft_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__